import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-call-room',
  templateUrl: './audio-call-room.component.html',
  styleUrls: ['./audio-call-room.component.scss']
})
export class AudioCallRoomComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }
  slidechat() {
    document.getElementById("show-user-detail").classList.toggle("open-chat-sidebar");
  }

  closechatside() {
    document.getElementById("show-user-detail").classList.remove("open-chat-sidebar");
  }

  slideuserchat() {
    document.getElementById("show-user-detail").classList.toggle("open-user-sidebar");
  }

  closeuserchatside() {
    document.getElementById("show-user-detail").classList.remove("open-user-sidebar");
  }
}
